import React, { useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { useAccount, useMsal } from '@azure/msal-react'
import { Avatar } from 'primereact/avatar'
import { Button } from 'primereact/button'
import { Divider } from 'primereact/divider'
import { OverlayPanel } from 'primereact/overlaypanel'

import TenantInfo from './TenantInfo'

function SignOutButton(): React.ReactElement {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { instance, accounts } = useMsal()
  const account = useAccount(accounts[0])
  const op = useRef<OverlayPanel | null>(null)

  const handleLogout = async (): Promise<void> => {
    await instance.logoutRedirect()
  }

  const handleSwitch = (): void => {
    op.current?.hide()
    navigate('/tenants/switch')
  }

  const getInitials = (name: any): string => {
    const firstLetter = name.substr(0, 1)
    const lastLetter = name.substr(name.indexOf(' ') + 1, 1)
    const initials = firstLetter + lastLetter
    return initials.toUpperCase()
  }

  return (
    <>
      <Button
        type="button"
        className="p-button-text p-button-plain"
        onClick={e => op.current?.toggle(e, undefined)}
      >
        <Avatar label={account?.name ? getInitials(account?.name) : ''} shape="circle" />
      </Button>
      <OverlayPanel ref={op}>
        <div className="flex">
          <div className="mr-2">
            <Avatar
              label={account?.name ? getInitials(account?.name) : ''}
              shape="circle"
              size="large"
            />
          </div>
          <div className="mr-2">
            <span className="font-bold">{account?.name}</span>
            <br />
            <small className="">{account?.username}</small>
          </div>
        </div>
        <TenantInfo>
          <Button
            className="p-button-sm p-button-text"
            label="switch"
            icon="pi pi-arrow-right"
            iconPos="right"
            onClick={() => handleSwitch()}
          />
        </TenantInfo>
        <Divider />
        <Button
          onClick={() => handleLogout()}
          label={t('common.account.signOut')}
          className="p-button-sm p-button-text p-button-plain"
          icon="pi pi-sign-out"
        />
      </OverlayPanel>
    </>
  )
}

export default SignOutButton
